export const BE_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DISPLAY_DATE_FORMAT = 'yyyy-MM-dd';
export const INVALID_DB_DATE = '0000-00-00 00:00:00';
export const DATE_FORMAT = 'MM/DD/YYYY';
export const TIME_WITH_PERIOD_FORMAT = 'hh:mm A';
export const TIME_WITH_SECONDS_FORMAT = 'hh:mm:ss';
export const TIME_24HOUR_WITH_MINUTES_FORMAT = 'HH:mm';
export const TIME_24HOUR_WITH_SECONDS_FORMAT = 'HH:mm:ss';

export const REPORT_DATE_FORMAT = (separator = ' ') =>
	`MMM${separator}DD${separator}YYYY`;

export const XLSX_REPORT_DATE_FORMAT = (separator = ' ') =>
	`YYYY${separator}MMM${separator}DD`;
// For use with the `date-fns` library
export const TIME_WITH_PERIOD_FORMAT_FNS = 'hh:mm a';
export const TIME_WITH_MINUTES_FORMAT_FNS = 'hh:mm';
export const TIME_WITH_MINUTES_SECONDS_FORMAT_FNS = 'HH:mm:ss';
export const TIME_MINUTES_SECONDS_A_FORMAT_FNS = 'hh:mm:ss aa';
export const SIMPLE_TIME_WITH_PERIOD_FORMAT_FNS = 'h:mm a';

/*
 * TODO: Replace DATE_FORMAT with the current value of DATE_FORMAT_FNS
 * when moment is removed
 */
export const DATE_FORMAT_FNS = 'MM/dd/yyyy';
export const BE_DATE_FORMAT_FNS = 'yyyy-MM-dd HH:mm:ss';
export const BE_DATE_TIME_FORMAT_FNS = 'YYYY-MM-DDTHH:mm:ss';
export const DEFAULT_SHORT_DATE_FORMAT_FNS = 'MM/dd';
export const INVENTORY_DATE_FORMAT = 'yyyy-MM-dd';
